var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('span',{staticClass:"c-build-version"},[_vm._v("\n    v"+_vm._s(_vm.version)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }